// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__5qcb-","outsideClickLayer":"popup_outsideClickLayer__8OHGG"};